module.exports = __webpack_public_path__ + "img/next-page.f07ab24a.svg";